import { render, staticRenderFns } from "./DefensesPanel.vue?vue&type=template&id=193ec698"
import script from "./DefensesPanel.vue?vue&type=script&lang=js"
export * from "./DefensesPanel.vue?vue&type=script&lang=js"
import style0 from "./DefensesPanel.vue?vue&type=style&index=0&id=193ec698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports